
import { commonErrToast, showToast } from '@/common/ts/toast'
import { defineComponent, ref, computed, PropType, onMounted } from '@vue/composition-api'
import type { GetExtendPageInfoRes, ProductType } from 'api/api-type'
import { getJoinInfo } from 'api/index'
import { showPersonInfoModal } from '@/common/biz/person-info-modal'

import Panel from './panel.vue'
import { NAME_MAP } from '@/common/biz/constants'
import { omega, params } from '@didi/driver-biz-sdk'
import { hideNavBar } from '@/common/ts/handler-nav-bar'

export default defineComponent({
  name: 'hot-insurance',
  components: {
    Panel
  },
  props: {
    insurances: {
      type: [Array, Object] as PropType<GetExtendPageInfoRes['product_data']>,
      default: () => {
        return []
      }
    }
  },
  setup(props) {
    const tabs = computed(() => {
      const insurances = props.insurances
      if (Array.isArray(insurances)) {
        return [{
          label: '全部',
          value: 0
        }, {
          label: '意外险',
          value: 1
        }, {
          label: '百万医疗',
          value: 3
        }]
      } else {
        const familyMap = {
          insurantSelf: '为自己',
          insurantSpouse: '为配偶',
          insurantChildren: '为子女'
        }
        const list = Object.keys(insurances).map(key => {
          return {
            label: familyMap[key],
            value: key
          }
        })
        list.sort((a, b) => {
          if (a.value === 'insurantSelf') return -1
          if (a.value === 'insurantSpouse' && b.value === 'insurantChildren') return -1
          return 1
        })
        return list
      }
    })

    const familyInsurantType = {
      insurantSelf: 1,
      insurantSpouse: 2,
      insurantChildren: 3
    }

    function clickItem(item: typeof list.value[0]) {
      omega.trackEvent('am_c_insure_medical_landpage_expense_sku_ck', {
        sku_type: item.policy_type,
        company_id: item.company_id,
        product_id: item.id,
        insurant_type: familyInsurantType[type.value] || 1
      })
      if (!item.actionable) {
        showToast('已达购买上限')
        return
      }
      const url = 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=BXyiliaozifei&lang=zh-CN&bc_appid=20000&appversion=BXyiliaozifei#/xpub?s=op-json-95wqh3P6d&cid=113430&cnt_id=22111515867'

      showPersonInfoModal(NAME_MAP[item.company_id], url).then(() => {
        getJoinInfo({
          item_id: item.insurance_type,
          company_id: item.company_id,
          product_id: item.id,
          policy_type: item.policy_type,
          is_self_play: 1,
          insurant_type: familyInsurantType[type.value] || 1
        }).then(res => {
          if (res.link) {
            if (
              item.company_id === 20003 ||
              item.company_id === 20004
            ) {
              hideNavBar()
            }
            window.location.href = res.link
          }
        }).catch(err => {
          commonErrToast(err)
        })
      })
    }

    const type = ref(Array.isArray(props.insurances) ? 0 : 'insurantSelf')
    function clickTab(index) {
      omega.trackEvent('wyc_c_insure_wallet_medical_expense_hot_tab_ck', {
        insurant_type: familyInsurantType[index] || 1
      })
      type.value = index
    }

    const list = computed<ProductType[]>(() => {
      const insurances = props.insurances
      if (!Array.isArray(insurances)) {
        return insurances[type.value] || insurances.insurantSelf
      }

      return type.value === 0 ? insurances : insurances.filter(item => item.category === type.value)
    })

    onMounted(() => {
      const urlParams = params.urlParams
      if (!urlParams.direct) return
      urlParams.tab_type && (type.value = urlParams.tab_type as string)

      const productId = Number(urlParams.product_id)
      if (!productId) return
      const item = list.value.find(item => {
        return item.id === productId
      })
      if (!item) return
      if (window.sessionStorage.getItem('medical_direct')) {
        return
      } else {
        window.sessionStorage.setItem('medical_direct', '1')
      }
      clickItem(item)
    })
    return {
      tabs,
      list,
      type,
      clickItem,
      clickTab
    }
  }
})
